<!-- 防缓存：无 ts 就自动刷新 -->
<script>
    (function () {
        if (!location.search.includes('ts=')) {
            location.replace(location.pathname + '?ts=' + Date.now() + location.hash);
        }
    })();
</script>

<template>
    <div class="tg-list">
        <van-pull-refresh
                v-model="isLoading"
                success-text="刷新成功"
                @refresh="onRefresh"
        >
            <!-- 置顶部分 -->
            <div v-for="(item,index) in frist"
                 :key="'top-'+index"
                 class="tg-item"
                 @click="addgroup(item.qz_url)">
                <van-image
                        round
                        fit="cover"
                        class="tg-avatar"
                        :src="item.url"/>
                <div class="tg-content">
                    <div class="tg-title">{{ item.title }}</div>
                    <div class="tg-subtitle">{{ item.el_title1 }}</div>
                </div>
                <van-image
                        v-if="item.rig_icon"
                        class="tg-badge"
                        :src="item.rig_icon"/>
                <div class="tg-divider"/>
            </div>

            <!-- 普通列表 -->
            <div v-for="(item,index) in qzlist"
                 :key="'item-'+index"
                 class="tg-item"
                 @click="addgroup(item.qz_url)">
                <van-image
                        round
                        fit="cover"
                        class="tg-avatar"
                        :src="item.url"/>
                <div class="tg-content">
                    <div class="tg-title">{{ item.title }}</div>
                    <div class="tg-subtitle">{{ item.el_title1 }}</div>
                </div>
                <van-image
                        v-if="item.rig_icon"
                        class="tg-badge"
                        :src="item.rig_icon"/>
                <div class="tg-divider"/>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
    import { Toast } from 'vant'
    export default {
        name: 'Home',
        data () {
            return {
                isLoading: false,
                frist: [
                    {
                        url: require('../assets/test/f1.jpg'),
                        title: '书墨资源丨各类资源分享交流群',
                        el_title1: '✈️@shumozyfx',
                        qz_url: '@shumozyfx',
                        rig_icon: require('../assets/top.gif')
                    },
                    {
                        url: require('../assets/test/f2.jpg'),
                        title: '看电影 学英语 Learn English',
                        el_title1: '✈️@EnglishVivid',
                        qz_url: '@EnglishVivid',
                        rig_icon: require('../assets/top.gif')
                    },
                    {
                        url: require('../assets/test/f3.jpg'),
                        title: 'TikTok520中文抖音国际版交流群',
                        el_title1: '✈️@tiktok520',
                        qz_url: '@tiktok520',
                        rig_icon: require('../assets/top.gif')
                    }
                ],
                qzlist: [],
                list: [
                    {
                        url: require('../assets/test/f4.jpg'),
                        title: 'TELE影院🚀电影分享🚀影视剧分享',
                        el_title1: '✈️@tgyy05',
                        qz_url: '@tgyy05',
                        rig_icon: require('../assets/xingmu.gif')
                    },
                    {
                        url: require('../assets/test/f5.jpg'),
                        title: '可以询问想看的电影，或交流电影，观后感。',
                        el_title1: '✈️@r21moviegroup',
                        qz_url: '@r21moviegroup',
                        rig_icon: require('../assets/xingmu.gif')
                    },
                    {
                        url: require('../assets/test/f6.jpg'),
                        title: '王者荣耀 和平精英 外挂',
                        el_title1: '✈️@wg0001',
                        qz_url: '@wg0001',
                        rig_icon: require('../assets/xingmu.gif')
                    },
                    {url: require('../assets/test/f7.jpg'),
                        title: '辅助交流 外挂，和平精英，吃鸡 cs，cf',
                        el_title1: '✈️@hepingjingying2',
                        el_url1: '@hepingjingying2',
                        qz_url: '@hepingjingying2',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f8.jpg'),
                        title: '网易云音乐♨️在线听歌',
                        el_title1: '✈️@WYY857999',
                        el_url1: '@WYY857999',
                        qz_url: '@WYY857999',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f9.jpg'),
                        title: '音乐搜索 音乐 搜索 下载 点歌',
                        el_title1: '✈️@VmoMusicSearch',
                        el_url1: '@VmoMusicSearch',
                        qz_url: '@VmoMusicSearch',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f10.jpg'),
                        title: '電報攝影群組，歡迎熱愛攝影朋友加入',
                        el_title1: '✈️@photographyintelegram',
                        el_url1: '@photographyintelegram',
                        qz_url: '@photographyintelegram',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f11.jpg'),
                        title: '叮当猫の交流聊天群，畅所欲言。',
                        el_title1: '✈️@ddm1024',
                        el_url1: '@ddm1024',
                        qz_url: '@ddm1024',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f12.jpg'),
                        title: '理工学科讨论群，谢绝广告。',
                        el_title1: '✈️@Science_Math',
                        el_url1: '@Science_Math',
                        qz_url: '@Science_Math',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f13.jpg'),
                        title: '科技&趣闻，分享有价值、有趣的信息。',
                        el_title1: '✈️@kejiquchat',
                        el_url1: '@kejiquchat',
                        qz_url: '@kejiquchat',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f14.jpg'),
                        title: '科技圈🎗の 茶馆',
                        el_title1: '✈️@ZaihuaChat',
                        el_url1: '@ZaihuaChat',
                        qz_url: '@ZaihuaChat',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f15.jpg'),
                        title: '欢迎加入Polygon(Matic)中文社区',
                        el_title1: '✈️@maticnetwork_china',
                        el_url1: '@maticnetwork_china',
                        qz_url: '@maticnetwork_china',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f16.jpg'),
                        title: '欧易OKX官方中文群',
                        el_title1: '✈️@OKXGroup_CN',
                        el_url1: '@OKXGroup_CN',
                        qz_url: '@OKXGroup_CN',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f17.jpg'),
                        title: '八卦杂谈，电影资讯，新闻科技，软件技巧',
                        el_title1: '✈️@jianjiaoQUN',
                        el_url1: '@jianjiaoQUN',
                        qz_url: '@jianjiaoQUN',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f18.jpg'),
                        title: '破解软件中文社群',
                        el_title1: '✈️@tfwzclz',
                        el_url1: '@tfwzclz',
                        qz_url: '@tfwzclz',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f19.jpg'),
                        title: 'APPDO 每日拍大腿说又后悔了群',
                        el_title1: '✈️@appdododo',
                        el_url1: '@appdododo',
                        qz_url: '@appdododo',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f20.jpg'),
                        title: '欢迎喜爱吉他和音乐的朋友进群交流学',
                        el_title1: '✈️@tg_guitar',
                        el_url1: '✈️@tg_guitar',
                        qz_url: '@tg_guitar',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f21.jpg'),
                        title: '神人們，我需要你們的美食情',
                        el_title1: '✈️@eattyn',
                        el_url1: '@eattyn',
                        qz_url: '@eattyn',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f22.jpg'),
                        title: '薄荷岛，旅行潜水小分队（接团建）',
                        el_title1: '✈️@bohol1',
                        el_url1: '@bohol1',
                        qz_url: '@bohol1',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f23.jpg'),
                        title: '本群主要讨论养猫相关知',
                        el_title1: '✈️@ingressmiao',
                        el_url1: '@ingressmiao',
                        qz_url: '@ingressmiao',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f24.jpg'),
                        title: '提供欧美剧，日韩剧，全球最新影视观看',
                        el_title1: '✈️@blackcatfilm_cc',
                        el_url1: '@blackcatfilm_cc',
                        qz_url: '@blackcatfilm_cc',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f25.jpg'),
                        title: '翻翻咱祖宗留下来各种经书各种乱七八糟的老东西',
                        el_title1: '✈️@Yiology',
                        el_url1: '@Yiology',
                        qz_url: '@Yiology',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f26.jpg'),
                        title: '大马🇲🇾二次元ACGN聊天群',
                        el_title1: '✈️@acgnchat',
                        el_url1: '@acgnchat',
                        qz_url: '@acgnchat',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f27.jpg'),
                        title: '迪拜 华人俱乐部欢迎您的加入',
                        el_title1: '✈️@GT1896',
                        el_url1: '@GT1896',
                        qz_url: '@GT1896',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f28.jpg'),
                        title: '专注于推动区块链',
                        el_title1: '✈️@wenwenhouhuayuan',
                        el_url1: '@wenwenhouhuayuan',
                        qz_url: '@wenwenhouhuayuan',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f29.jpg'),
                        title: '黑科技软件资源分享交流群',
                        el_title1: '✈️@blacktechsharing',
                        el_url1: '@blacktechsharing',
                        qz_url: '@blacktechsharing',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f30.jpg'),
                        title: '柬埔寨华人商业联合🇰🇭Cambodia',
                        el_title1: '✈️@xigangdehuaren',
                        el_url1: '@xigangdehuaren',
                        qz_url: '@xigangdehuaren',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f31.jpg'),
                        title: '八字，紫微，面手，六爻，梅花算命玄学',
                        el_title1: '✈️@nuomiMe13',
                        el_url1: '@nuomiMe13',
                        qz_url: '@nuomiMe13',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f32.jpg'),
                        title: '谢绝政治话题讨论，专注技术和侃大山。',
                        el_title1: '✈️@gov2ex',
                        el_url1: '@gov2ex',
                        qz_url: '@gov2ex',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f33.jpg'),
                        title: '歡迎加入澳門信用卡優惠情報組。',
                        el_title1: '✈️@smartcardmacaogroup',
                        el_url1: '@smartcardmacaogroup',
                        qz_url: '@smartcardmacaogroup',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f34.jpg'),
                        title: '法客電台 by 法律白話文運動',
                        el_title1: '✈️@plmradio',
                        el_url1: '@plmradio',
                        qz_url: '@plmradio',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f35.jpg'),
                        title: '欢迎来到五眼联盟出国移民群。',
                        el_title1: '✈️@chuguoyimin',
                        el_url1: '@chuguoyimin',
                        qz_url: '@chuguoyimin',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f36.jpg'),
                        title: '澳洲华人电报群',
                        el_title1: '✈️@OZSteps',
                        el_url1: '@OZSteps',
                        qz_url: '@OZSteps',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f37.jpg'),
                        title: '关注 Netflix 影视资源和观影心得。',
                        el_title1: '✈️@netflixchina',
                        el_url1: '@netflixchina',
                        qz_url: '@netflixchina',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f38.jpg'),
                        title: '内涵段子之狼人杀',
                        el_title1: '✈️@werewolfcn',
                        el_url1: '@werewolfcn',
                        qz_url: '@werewolfcn',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f39.jpg'),
                        title: '东南亚交流群-人间温暖🦋',
                        el_title1: '✈️@mppay',
                        el_url1: '@mppay',
                        qz_url: '@mppay',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f40.jpg'),
                        title: 'ChatGPT AI机器人使用交流讨论',
                        el_title1: '✈️@gpt_user',
                        el_url1: '@gpt_user',
                        qz_url: '@gpt_user',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f41.jpg'),
                        title: '歡迎加入本群組討論cosplay,遊戲,動漫',
                        el_title1: '✈️@cosplaysharegroup',
                        el_url1: '@cosplaysharegroup',
                        qz_url: '@cosplaysharegroup',
                        rig_icon: require('../assets/xingmu.gif')},
                    {url: require('../assets/test/f42.jpg'),
                        title: '手机💖海外🌕学生全球▶️TG资源',
                        el_title1: '✈️@ziyuan113',
                        el_url1: '@ziyuan113',
                        qz_url: '@ziyuan113',
                        rig_icon: require('../assets/xingmu.gif')},
                ]
            }
        },
        mounted () {
            this.shuffle(this.list)
            this.qzlist = [...this.list]
        },
        methods: {
            shuffle (arr) {
                for (let i = arr.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1))
                    ;[arr[i], arr[j]] = [arr[j], arr[i]]
                }
            },
            onRefresh () {
                setTimeout(() => {
                    location.reload()
                    Toast('刷新成功')
                    this.isLoading = false
                }, 1200)
            },
            addgroup (val) {
                document.location = 'appjs://webview?path=' + val
            }
        }
    }
</script>

<style scoped lang="less">
    .tg-list{
        background: #ffffff;
    }
    .tg-item{
        position: relative;
        display: flex;
        align-items: center;
        height: 72px;
        padding: 0 16px;
        background: #ffffff;
    }
    .tg-avatar{
        width: 55px;
        height: 55px;
        border-radius: 50%;
        flex-shrink: 0;
    }
    .tg-content{
        flex: 1;
        margin-left: 16px;
        overflow: hidden;      /* 保证省略号生效 */
    }
    .tg-title{
        font-size: 17px;
        color: #222;
        font-weight: 600;
        line-height: 22px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .tg-subtitle{
        font-size: 14px;
        color: #8a8a8a;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 2px;
    }
    /* 右上角小图标 */
    .tg-badge{
        width: 20px;
        height: 20px;
        margin-left: 8px;
        flex-shrink: 0;
    }
    /* 分割线：右边顶格，左边与文字对齐 */
    .tg-divider{
        position: absolute;
        bottom: 0;
        left: 72px;   /* 16 padding + 56 avatar + 0 文字已另16 margin */
        right: 0;
        height: 0.8px;
        background: #e9eaec;
    }
</style>
